<script lang="ts" setup>
export interface AIconButtonProperties {
  label: string
}
defineProps<AIconButtonProperties>()

export interface AIconButtonEmits {
  (event: 'click', payload: MouseEvent | KeyboardEvent): void
}
const emit = defineEmits<AIconButtonEmits>()

function onClick(event: MouseEvent) {
  emit('click', event)
}

function onKeydown(event: KeyboardEvent) {
  if (event.key === 'Enter' || event.key === ' ') {
    event.preventDefault()
    emit('click', event)
  }
}
</script>

<template>
  <button ref="buttonRef" :aria-label="label" class="icon-button" @click="onClick" @keydown="onKeydown">
    <slot></slot>
  </button>
</template>

<style lang="scss" scoped>
.icon-button {
}
</style>
